import { Base } from './_base';
import get from 'lodash-es/get';
import { EntryPointBackend } from '@pbx/models/worksheet-actions/backend/entry-point';
import { merge_by_template } from '@shared/helpers/collections';

export class EntryPointFrontend extends Base {
  constructor(item) {
    super(item);
    this.type = 'entry';
    this.data = merge_by_template(item.data || {}, {
      params: {
        number_id: null,
        caller_id: null,
        hide_incoming_number: false,
        record_type: 'no'
      },
      options: {
        next: null
      }
    });
  }

  isAllowedIncomingConnection() {
    return false;
  }

  toBackend() {
    const base_transform = super.toBaseBackend();

    const params = get(base_transform, 'data.params', {});
    const options = get(base_transform, 'data.options', {});

    const options_transform = {
      action_id: options.next || null
    };

    return new EntryPointBackend({
      ...base_transform,
      ...options_transform,
      ...params
    });
  }
}
